const state = {
  rightDrawer: false,
  rightDrawerComponent: ''
}

const mutations = {
  openRightDrawer (state) {
    state.rightDrawer = true
  },
  closeRightDrawer (state) {
    state.rightDrawer = false
  },
  setRightDrawerComponent (state, component) {
    state.rightDrawerComponent = component
  }

}

const actions = {
  openRightDrawer ({ commit }, payload) {
    commit('setRightDrawerComponent', payload)
    commit('openRightDrawer')
  },

  closeRightDrawer ({ commit }) {
    commit('closeRightDrawer')
  }
}

export const layoutevents = {
  namespaced: true,
  state,
  mutations,
  actions
}
